import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavLink,
  Collapse,
} from "reactstrap";
import "./MultiDropdown.css";
import { Link, useParams, matchPath, useLocation } from "react-router-dom";
import { createSlug } from "../../utilis/slugUtilis";
import TravelLinkService from "../../services/TravelLinkService/TravelLinkService";
import "./MultiDropdown.css";

const MultiLevelDropdown = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [openMobileDropdowns, setOpenMobileDropdowns] = useState(new Set());
  const [hoveredItems, setHoveredItems] = useState(new Set());
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  // Check if the link is active
  const isActiveLink = (path) =>
    path === "/"
      ? location.pathname === path
      : matchPath({ path, end: false }, location.pathname);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setOpenMobileDropdowns(new Set()); // Reset mobile dropdowns when switching to desktop
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch menu data
  const [data, setData] = useState([]);
  const fetchMenu = async () => {
    try {
      const response = await TravelLinkService.getMenu();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMenu();
  }, []);

  // Mobile dropdown toggle
  const toggleMobileDropdown = (uniqueId, e) => {
    e.stopPropagation(); // Prevents the link's parent from being affected
    setOpenMobileDropdowns((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(uniqueId)) {
        newSet.delete(uniqueId);
      } else {
        newSet.add(uniqueId);
      }
      return newSet;
    });
  };

  // Desktop hover handlers
  const handleMouseEnter = (uniqueId) => {
    if (!isMobile) {
      setHoveredItems((prev) => new Set([...prev, uniqueId]));
    }
  };

  const handleMouseLeave = (uniqueId) => {
    if (!isMobile) {
      setHoveredItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(uniqueId);
        return newSet;
      });
    }
  };

  // Render dropdown items recursively
  const renderDropdownItems = (items, level = 0, parentId = "") => {
    return items.map((item) => {
      const hasChildren = item.children && item.children.length > 0;
      const uniqueId = `${parentId}-${item.title}-${level}`;
      const currentPath = `${item.url}`;
      const isHovered = hoveredItems.has(uniqueId);
      const isMobileOpen = openMobileDropdowns.has(uniqueId);

      const linkStyles = {
        color: isActiveLink(currentPath) ? "#0E9EDA" : "#0E9EDA",
        fontWeight: isActiveLink(currentPath) ? "bold" : "normal",
      };

      // Function to close the sidebar when a link is clicked
      const handleLinkClick = () => {
        if (window.innerWidth < 768) {
          setSidebarOpen(false); // Close sidebar on small screen
        }
      };

      if (hasChildren) {
        return (
          <li
            key={uniqueId}
            className={`nav-item ${isMobile ? "mobile" : ""}`}
            onMouseEnter={() => handleMouseEnter(uniqueId)}
            onMouseLeave={() => handleMouseLeave(uniqueId)}
          >
            <div className="nav-link d-flex justify-content-between align-items-center">
              <Link
                to={currentPath}
                className="nav-link"
                style={linkStyles}
                onClick={handleLinkClick}
              >
                {item.title}
              </Link>

              {isMobile && hasChildren && (
                <span
                  className="mobile-caret"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleMobileDropdown(uniqueId, e);
                  }}
                >
                  <i
                    className={`bx ${
                      isMobileOpen ? "bx-chevron-down" : "bx-chevron-right"
                    }`}
                  ></i>
                </span>
              )}
            </div>

            <ul
              className={`dropdown-menu ${
                isMobile
                  ? isMobileOpen
                    ? "show"
                    : ""
                  : isHovered
                  ? "show"
                  : ""
              }`}
            >
              {renderDropdownItems(item.children, level + 1, uniqueId)}
            </ul>
          </li>
        );
      }

      return (
        <li
          key={uniqueId}
          className="nav-item"
          onMouseEnter={() => handleMouseEnter(uniqueId)}
          onMouseLeave={() => handleMouseLeave(uniqueId)}
        >
          <Link
            to={currentPath}
            className="nav-link"
            style={linkStyles}
            onClick={handleLinkClick} // Close sidebar on small screens
          >
            {item.title}
          </Link>
        </li>
      );
    });
  };

  return (
    <ul className="list-unstyled d-flex m-0 p-0 mt-0 gap-4 mb-3">
      {renderDropdownItems(data)}
    </ul>
  );
};
export default MultiLevelDropdown;
